import { ConnectionPoint } from '../../models';
import * as CP from './connectionPoints.constants';

export function loadConnectionPointsSuccess(data: ConnectionPoint[]) {
    return { type: CP.CONNECTION_POINTS_LOAD_SUCCESS, payload: data };
}

export function duplicate(guid: string) {
    return { type: CP.CONNECTION_POINT_DUPLICATE, payload: guid };
}
export function duplicateSuccess(guid: string) {
    return { type: CP.CONNECTION_POINT_DUPLICATE_SUCCESS, payload: guid };
}
export function duplicateError(error: any) {
    return { type: CP.CONNECTION_POINT_DUPLICATE_ERROR, payload: error };
}

export function deleteConnectionPoint(guid: string) {
    return { type: CP.CONNECTION_POINT_DELETE, payload: guid };
}
export function deleteSuccess(guid: string) {
    return { type: CP.CONNECTION_POINT_DELETE_SUCCESS, payload: guid };
}
export function deleteError(error: any) {
    return { type: CP.CONNECTION_POINT_DELETE_ERROR, payload: error };
}